// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","SubscribedPhotoblogs":"tl_a bic_b bic_bj","SubscribedPhotoblogs__link":"tl_b bic_a bic_r"};